import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../ConfirmModal';

const ResetSchedulerModal = (props) => {
  const { t } = useTranslation();
  const title =  t('resetScheduleLabel');
  const description = t('resetScheduleConfirmMessage');
  return (
    <ConfirmModal
      title={title}
      description={description}
      {...props}
    />
  );
};

export default ResetSchedulerModal;